/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["fɔŋli","ŋdi","ŋdɔ","ɣetrɔ","fiẽ","zã"],u,u],u,[["04:00","05:00"],["05:00","12:00"],["12:00","14:00"],["14:00","18:00"],["18:00","21:00"],["21:00","04:00"]]];
